import {
  apiRequest,
  cp3kUploadSK,
  cp3kDetail,
  masterSignatoryOfficial,
  cp3kDownloadSPMT,
  cp3kDownloadPlanLetter,
} from "../../../../../services/adapters/kepegawaian/cp3kService";

class UploadSKRepository {
  fetchUploadSk = async (query) => {
    return await apiRequest(
      "post",
      cp3kUploadSK,
      {
        body: query,
      },
      true
    );
  };

  fetchDownloadSPMT = async (query) => {
    return await apiRequest(
      "get",
      cp3kDownloadSPMT,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadPlanLetter = async (query) => {
    return await apiRequest(
      "get",
      cp3kDownloadPlanLetter,
      {
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      cp3kDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchSignatoryOfficial = async (query) => {
    return await apiRequest(
      "get",
      masterSignatoryOfficial,
      {
        params: query,
      },
      true
    );
  };
}

export default UploadSKRepository;
